module.exports = __webpack_public_path__ + "static/media/x-icon.c019bd43.png";